import { render, staticRenderFns } from "./FeedbackSubmitted.vue?vue&type=template&id=ae827724&"
import script from "./FeedbackSubmitted.vue?vue&type=script&lang=js&"
export * from "./FeedbackSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports